import { AccordionContainer } from './AccordionContainer';
import { AccordionProps } from '@/shared/types/accordion';

/**
 * Accordion - Componente de acordeón expandible
 *
 * Componente que permite mostrar/ocultar contenido de forma expandible.
 * Soporta múltiples items, estados controlados y no controlados.
 *
 * @example
 * ```tsx
 * // Accordion simple
 * <Accordion
 *   items={[
 *     { id: '1', title: 'Sección 1', content: 'Contenido 1' },
 *     { id: '2', title: 'Sección 2', content: 'Contenido 2' }
 *   ]}
 * />
 *
 * // Accordion controlado
 * <Accordion
 *   items={items}
 *   openItems={['1']}
 *   onToggle={(id) => setOpenItems([id])}
 * />
 * ```
 *
 * @see {@link AccordionProps} para la lista completa de props
 * @see {@link AccordionContainer} para la implementación interna
 */
export const Accordion = (props: AccordionProps) => {
  return <AccordionContainer {...props} />;
};
